import React, { ReactElement } from 'react'

import { TransactionsListFiltersContextProvider } from './contexts/transactionsListFiltersContext'
import { TransactionsList } from './routes/TransactionsList'

export const Transactions = (): ReactElement => {
  return (
    <TransactionsListFiltersContextProvider>
      <TransactionsList />
    </TransactionsListFiltersContextProvider>
  )
}
